import { render, staticRenderFns } from "./InvoicesStatistics.vue?vue&type=template&id=ea5d82ec&scoped=true&"
import script from "./InvoicesStatistics.vue?vue&type=script&lang=js&"
export * from "./InvoicesStatistics.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/statistics.styl?vue&type=style&index=0&id=ea5d82ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5d82ec",
  null
  
)

export default component.exports